import { useEffect, useState } from "react";
import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";

import { getCategories, getCourses } from "@/services/courseService";
import { ROUTE } from "@/route/app_routes.js";

const CATEGORY_ICON_RULES = [
  ["full-stack", "feather-layers"],
  ["fullstack", "feather-layers"],
  ["frontend", "feather-monitor"],
  ["front-end", "feather-monitor"],
  ["backend", "feather-server"],
  ["back-end", "feather-server"],
  ["mobile", "feather-smartphone"],
  ["data", "feather-bar-chart-2"],
  ["cloud", "feather-cloud"],
  ["devops", "feather-git-branch"],
  ["blockchain", "feather-link"],
  ["ui/ux", "feather-pen-tool"],
  ["design", "feather-pen-tool"],
  ["security", "feather-shield"],
  ["cyber", "feather-shield"],
  ["product", "feather-clipboard"],
  ["web", "feather-code"],
];

const iconFor = (name) => {
  const lower = (name || "").toLowerCase();
  const match = CATEGORY_ICON_RULES.find(([keyword]) => lower.includes(keyword));
  return match ? match[1] : "feather-compass";
};

const AdvanceTab = () => {
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories()
      .then((res) => {
        const cats = res.data || [];
        setCategories(cats);
        if (cats.length > 0) setActiveCategory(cats[0].name);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!activeCategory) return;
    setLoading(true);
    getCourses({ page: 1, category: activeCategory, per_page: 3 })
      .then((res) => setCourses(res.data?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [activeCategory]);

  if (categories.length === 0) return null;

  return (
    <div className="rbt-path">
      <div className="rbt-path__tabs">
        {categories.map((cat) => (
          <button
            type="button"
            className={`rbt-path__tab ${activeCategory === cat.name ? "is-active" : ""}`}
            onClick={() => setActiveCategory(cat.name)}
            key={cat.slug}
          >
            <span className="rbt-path__tab-icon">
              <i className={iconFor(cat.name)}></i>
            </span>
            <span className="rbt-path__tab-copy">
              <span className="rbt-path__tab-title">{cat.name}</span>
              <span className="rbt-path__tab-sub">
                {cat.course_count} free course{cat.course_count !== 1 ? "s" : ""}
              </span>
            </span>
            <i className="feather-chevron-right rbt-path__tab-caret"></i>
          </button>
        ))}
      </div>

      <div>
        <div className="rbt-path__panel">
          {loading
            ? Array.from({ length: 3 }).map((_, i) => (
                <div className="rbt-course-card" key={i}>
                  <div className="rbt-skel rbt-course-card__skel-media" />
                  <div className="rbt-course-card__body">
                    <div className="rbt-skel rbt-course-card__skel-line rbt-course-card__skel-line--w90" style={{ height: 14 }} />
                    <div className="rbt-skel rbt-course-card__skel-line rbt-course-card__skel-line--w60" style={{ height: 14 }} />
                  </div>
                </div>
              ))
            : courses.map((course) => (
                <Link className="rbt-course-card" href={`${ROUTE.course_details}${course.id}`} key={course.id}>
                  <div className="rbt-course-card__media">
                    <LazyImage
                      src={course.course_image_small}
                      alt={course.title}
                      fill
                      loading="lazy"
                      sizes="(max-width: 767px) 90vw, 30vw"
                    />
                    <div className="rbt-course-card__badges">
                      <span />
                      <span className="rbt-course-card__free">Free</span>
                    </div>
                  </div>
                  <div className="rbt-course-card__body">
                    <h3 className="rbt-course-card__title">{course.title}</h3>
                    <div className="rbt-course-card__foot">
                      <span className="rbt-course-card__level">{course.skill_level || "All levels"}</span>
                      <span className="rbt-course-card__cta">
                        View <i className="feather-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
        </div>

        {!loading && activeCategory && (
          <div className="text-center mt--40">
            <Link
              className="rbt-btn btn-border icon-hover radius-round"
              href={`${ROUTE.course}?category=${encodeURIComponent(activeCategory)}`}
            >
              <span className="btn-text">See all {activeCategory} courses</span>
              <span className="btn-icon"><i className="feather-arrow-right"></i></span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvanceTab;
